const FIREBASE_STORAGE_PATTERNS = [
    'firebasestorage.googleapis.com/',
    'https://storage.googleapis.com/balu-stage.appspot.com/',
    'https://storage.googleapis.com/balu-4523d.appspot.com/',
];

const PROXY_ENV_MAP = {
    middle: process.env.NEXT_PUBLIC_BUNNY_PROXY_MIDDLE_IMGS,
    big: process.env.NEXT_PUBLIC_BUNNY_PROXY_BIG_IMGS,
    small: process.env.NEXT_PUBLIC_BUNNY_PROXY_SMALL_IMGS,
} as const;

export function parseImg(
    url: any,
    type: 'middle' | 'big' | 'small' = 'big'
): any {
    if (!url) {
        return null;
    }
    if (url.includes('googleusercontent')) {
        return url;
    }

    const isFirebaseStorage = FIREBASE_STORAGE_PATTERNS.some((pattern) =>
        url.includes(pattern)
    );

    if (!isFirebaseStorage) {
        return url;
    }

    let part: string;

    if (url.includes('/o/')) {
        part = url.split('/o/')[1];
    } else {
        const baseUrl = FIREBASE_STORAGE_PATTERNS.find((pattern) =>
            url.includes(pattern)
        );
        part = baseUrl ? url.split(baseUrl)[1] : url;
    }

    if (!part || part.length <= 1) {
        return url;
    }

    // Remove query parameters
    part = part.split('?')[0];

    const proxyBase = PROXY_ENV_MAP[type];

    if (!proxyBase) {
        return url;
    }

    return `${proxyBase}${part}@jpeg`;
}
